import {Benchlearning} from "../benchmarking";

export class Compare{
  curRo: Benchlearning = new Benchlearning();
  compareRo: Benchlearning = new Benchlearning();
  ros: Benchlearning[] = [];
}
